import {ModuleWithProviders, NgModule} from '@angular/core';
import {SharedComponent} from './shared.component';
import {PreloaderComponent} from './components/preloader/preloader.component';
import {CommonModule} from '@angular/common';
import {QuestionaireComponent} from './components/questionaire/questionaire.component';
import {SlidesComponent} from './components/slides/slides.component';
import {SlideComponent} from './components/slides/slide/slide.component';
import {HeatmapComponent} from './components/slides/heatmap/heatmap.component';
import {HeatmapDirective} from './components/slides/heatmap/heatmap.directive';
import {FormlyModule} from '@ngx-formly/core';
import {FormsModule} from '@angular/forms';
import {SafeHtmlPipe} from './services/safe-html.pipe';
import {Configurations} from 'projects/shared/src/lib/services/configurations';
import {PromoHandlerComponent} from './components/promo-handler/promo-handler.component';
import {RadioFieldWrapperComponent} from './components/formly-components/radio-field-wrapper/radio-field-wrapper.component';
import {VideoPlayerComponent} from './components/video-player/video-player.component';
import {YouTubePlayerModule} from '@angular/youtube-player';
import {NgbAccordionModule, NgbProgressbarModule} from '@ng-bootstrap/ng-bootstrap';
import { PromoCodeHandlerComponent } from './components/promo-code-handler/promo-code-handler.component';
import { AiAssistantComponent } from './components/ai-assistant/ai-assistant.component';
import { MorphComponent } from './components/morph/morph.component';
import { ProgressbarStackedComponent } from './components/progressbar-stacked/progressbar-stacked.component';
import { LineChartFilledComponent } from './components/line-chart-filled/line-chart-filled.component';
import { MixedChartComponent } from './components/mixed-chart/mixed-chart.component';
import { BurnoutChartComponent } from './components/burnout-chart/burnout-chart.component';
import { UserProgressComponent } from './components/user-progress/user-progress.component';
import {SlickCarouselModule} from 'ngx-slick-carousel';

@NgModule({
    declarations: [
        SharedComponent,
        PreloaderComponent,
        QuestionaireComponent,
        SlidesComponent,
        SlideComponent,
        HeatmapComponent,
        HeatmapDirective,
        SafeHtmlPipe,
        PromoHandlerComponent,
        RadioFieldWrapperComponent,
        VideoPlayerComponent,
        PromoCodeHandlerComponent,
        AiAssistantComponent,
        MorphComponent,
        ProgressbarStackedComponent,
        LineChartFilledComponent,
        MixedChartComponent,
        BurnoutChartComponent,
        UserProgressComponent
    ],
    imports: [
        CommonModule,
        FormlyModule.forRoot({
            wrappers: [
                {name: 'radio', component: RadioFieldWrapperComponent},
            ],
        }),
        FormsModule,
        YouTubePlayerModule,
        NgbProgressbarModule,
        NgbAccordionModule,
        NgbProgressbarModule,
        SlickCarouselModule
    ],
    exports: [
        SharedComponent,
        PreloaderComponent,
        QuestionaireComponent,
        SlidesComponent,
        SlideComponent,
        HeatmapComponent,
        PromoHandlerComponent,
        PromoCodeHandlerComponent,
        VideoPlayerComponent,
        SafeHtmlPipe,
        AiAssistantComponent,
        MorphComponent,
        ProgressbarStackedComponent,
        LineChartFilledComponent,
        MixedChartComponent,
        BurnoutChartComponent,
        UserProgressComponent
    ]
})
export class SharedModule {
    public static forRoot(config: Configurations): ModuleWithProviders<SharedModule> {

        return {
            ngModule: SharedModule,
            providers: [
                {provide: Configurations, useValue: config}
            ]
        };
    }
}
